import {styled} from 'styled-components';
import {Table, TableColumnsType} from 'antd';
import {columnsCallsReport} from './columns';
import {colors} from '../../../styles';
import {textMixin} from '../../../styles/mixins';

interface TableData {
    key: React.Key;
    SUM: number;
    CURRENCYTYPE?: string;
    CURRENCY?: string;
    ORIGINALSUN?: number;
    SHIFTDATE?: string;
    nested?: TableData[];
}

const columns: TableColumnsType<TableData> = columnsCallsReport;

const CallsReport = ({dataValues, loading}) => {
    return (
        <StyledTable>
            <Table
                pagination={false}
                dataSource={dataValues}
                loading={loading}
                columns={columns}
                size="small"
                summary={(pageData) => {
                    let sumSuccess = 0;
                    let sumMissed = 0;
                    let sumAutoanswer = 0;
                    let sumAmount = 0;
                    pageData.forEach(
                        ({
                            totalSuccess,
                            totalMissed,
                            totalAutoanswer,
                            totalAmount,
                        }: any) => {
                            sumSuccess += totalSuccess;
                            sumMissed += totalMissed;
                            sumAutoanswer += totalAutoanswer;
                            sumAmount += totalAmount;
                        }
                    );

                    return (
                        <>
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0}>
                                    Всего
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU').format(
                                            Number(sumSuccess)
                                        )}
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU', {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1,
                                        }).format(
                                            Number(
                                                (sumSuccess / sumAmount) * 100
                                            )
                                        )}{' '}
                                        %
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU').format(
                                            Number(sumMissed)
                                        )}
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU', {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1,
                                        }).format(
                                            Number(
                                                (sumMissed / sumAmount) * 100
                                            )
                                        )}{' '}
                                        %
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU').format(
                                            Number(sumAutoanswer)
                                        )}
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU', {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1,
                                        }).format(
                                            Number(
                                                (sumAutoanswer / sumAmount) *
                                                    100
                                            )
                                        )}{' '}
                                        %
                                    </StyledSum>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>
                                    <StyledSum>
                                        {new Intl.NumberFormat('ru-RU').format(
                                            Number(sumAmount)
                                        )}
                                    </StyledSum>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </>
                    );
                }}
                rowClassName={() => 'main-row'}
            />
        </StyledTable>
    );
};

export default CallsReport;

const StyledTable = styled.div`
    .ant-table-thead > tr > th {
        background-color: ${colors.tableHeadBg};
        border-radius: 0px !important;
        line-height: 16.8px;
        height: 50px;
        line-height: 17px;
        text-align: center;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        height: 45px;
        padding-right: 1.1em !important;
    }

    .ant-table-summary {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16.8px;
        text-align: left;
    }
    tr > td:first-child {
        border-bottom-left-radius: 8px !important;
    }

    tr > td:last-child {
        border-bottom-right-radius: 8px !important;
    }

    .ant-table-row-indent {
        padding-left: 15px !important;
    }
    .indent-level-1 {
        padding-left: 22px !important;
    }

    table > tbody > tr > td {
        background-color: ${colors.cleanWhite};
        border: 1px solid #efefef;
        color: ${colors.grey};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 16.8px;
        text-align: left;
        height: 30px;
    }

    .parent-row td {
        font-weight: 600;
    }

    .child-row td {
        font-weight: 400;
    }

    .ant-table-expanded-row > td {
        padding-left: 20px !important;
        background-color: #f9f9f9;
    }
`;

const StyledSum = styled.div`
    text-align: right;
    padding-right: 0.5em;
    font-weight: 400;
`;
